<template>
    <div class="dropdown-text" @click="redirect">
        <span>{{ resource.name }}</span><br>
        <small>{{ resource.trajectory_type ? resource.trajectory_type.value : '-' }}</small>
    </div>
</template>

<script>
import globalSearch from "~/mixins/global-search";

export default {
    name: "trajectories-result.vue",
    mixins: [globalSearch],
    computed: {
        redirectName: function () {
            return `admin.trajectory_projects.trajectories.view`
        },
        redirectParams: function () {
            return {
                projectId: this.resource.trajectory_project_id,
                id: this.resource.id
            }
        }
    }
}
</script>

<style scoped>

</style>
